import { PaymentFormValues, PaymentMethod } from '@model/forms';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum PaymentActions {
  NAME = '@PAYMENT_FORM',
  ON_ADDRESS_FORM_CHANGE = '@PAYMENT_FORM/onAddressFormChange',
  ON_PAYMENT_FORM_CHANGE = '@PAYMENT_FORM/onPaymentFormChange',
  RESET_PAYMENT_FORM = '@PAYMENT_FORM/RESET_PAYMENT_FORM'
}

export const INITIAL_PAYMENT_FORM_STATE: PaymentFormValues = {
  contactByPost: false,
  companyName: '',
  buildingNameOrNumber: '',
  street: '',
  address: '',
  address2: '',
  townCity: '',
  county: '',
  postCode: '',
  country: '',
  countryIso2: '',
  discountCode: '',
  paymentMethod: PaymentMethod.FULL_AMOUNT,
  cardNumber: '',
  cardExpiryDate: '',
  cvv: '',
  termsAccepted: false,
  nameOnCard: '',
  amount: '',
  totalOutstandingAmount: 0,
  tradeEmail: '',
  cardholderName: ''
};

const paymentFormSlice = createSlice({
  name: PaymentActions.NAME,
  initialState: INITIAL_PAYMENT_FORM_STATE,
  reducers: {
    onAddressFormChange: (state, action: PayloadAction<any>) => {
      return { ...state, ...action.payload };
    },
    onPaymentFormChange: (state, action: PayloadAction<PaymentFormValues>) => {
      return { ...state, ...action.payload };
    },
    resetPaymentForm: () => {
      return INITIAL_PAYMENT_FORM_STATE;
    }
  }
});

export const { onAddressFormChange, onPaymentFormChange, resetPaymentForm } = paymentFormSlice.actions;

export const paymentFormReducer = paymentFormSlice.reducer;
